import { SurveyOutlineTypes, SurveyStepItemTypes } from '../types/survey';

const reverseChoices = (surveyOutline: SurveyOutlineTypes, deviceVariant: string) => {
  if (deviceVariant === 'pc') return surveyOutline;
  const newSurveyStepItems = surveyOutline.currentSurveyStep.surveyStepItems.map(
    (surveyStepItem: SurveyStepItemTypes) => {
      if (
        surveyStepItem.type &&
        !surveyStepItem.type.match(/^Surveys::StepItems::Questions::Engagements/)
      ) {
        return surveyStepItem;
      }

      const { choices } = surveyStepItem;
      if (!choices || !choices.length) return surveyStepItem;

      const newChoices = [...choices];
      newChoices.sort((a, b) => {
        if (a.value && b.value && a.value < b.value) {
          return 1;
        }
        return -1;
      });
      return {
        ...surveyStepItem,
        choices: newChoices,
      };
    },
  );

  const newSurveyStep = {
    ...surveyOutline.currentSurveyStep,
    surveyStepItems: newSurveyStepItems,
  };

  return {
    ...surveyOutline,
    currentSurveyStep: newSurveyStep,
  };
};

export default reverseChoices;
